<template>
  <div>
    <input-validate title="Name" type="text" name="pnname" v-model="pnname" placeholder="Enter your name"
                    v-validate="'required|pnname'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
                    :error="errors.first('pnname')">
    </input-validate>
    <input-validate title="Account" type="text" name="account" v-model="account" placeholder="Enter your account"
                    v-validate="'required|account'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
                    :error="errors.first('account')">
    </input-validate>
    <div v-if="backup_upi.length > 0">
      <md-field-item title="UPI" :content="upi" @click="showSelector" arrow solid/>
    </div>
    <md-selector v-model="isSelectorupiShow" default-value="2" :data="backup_upi" max-height="320px" title="UPI list"
                 large-radius @choose="onSelectorChoose"></md-selector>
    <a ref="myLink" :href="linkurl"></a>
    <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct"
               v-if="viewOperate === 'edit'">Save
    </md-button>
    <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct" v-else>{{
        btn_name
      }}
    </md-button>
  </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import {Validator} from "vee-validate";
import inputValidate from "@/components/input-validate";
import {editcollectiontool, monitorflowone, monitorflowtwo, monitorflowcheck} from '@/request/api'
import {Dialog} from "mand-mobile";

Validator.extend("account", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => /^\d{10}$/.test(value)
});
// Validator.extend("upiid", {
//     getMessage: field => `${field} value do not meet right format`,
//     validate: value => /^[\s\S]*@[\s\S]*$/.test(value)
// });
Validator.extend("pnname", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => {
    return true
  }
});


export default {
  name: 'clientlogin',
  components: {
    topback,
    iconimg,
    inputValidate
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    ct: {
      type: Object,
      default: null
    },
    operate: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      edit: false,
      account: "",
      pnname: "",
      link_loading: false,
      monitor_pk: "",
      monitor_check_interval: "",
      check_count: 0,
      isSelectorupiShow: false,
      upi: "select available upi",
      backup_upi: [],
      btn_name: "Link Kyc",
      ct_id: "",
      linkurl: "",
      viewOperate: "add",
    }
  },
  created() {
    this.viewOperate = this.operate;
    console.log("this.operate: ", this.viewOperate);
    if (this.ct) {
      this.account = this.ct.account;
      this.pnname = this.ct.pnname;
      this.backup_upi = this.format_backup_upi(this.ct.backup_upi);
      this.upi = this.ct.upi || "select available upi";
      this.edit = true;
      this.ct_id = this.ct.id;
    } else {
      this.account = "";
      this.pnname = "";
      this.edit = false;
    }
  },
  mounted() {
    window.onerror = function (msg, source, line, column, err) {
      console.log('window.onerror----', msg, source, line, column, err);
      return true;
    }
  },
  watch: {
    operate(newVal) {
      this.viewOperate = newVal;
    }
  },
  methods: {
    format_backup_upi(backup_upi) {
      let backup_upi_kv = []
      if (backup_upi) {
        backup_upi.forEach(upi => {
          backup_upi_kv.push({
            value: upi,
            text: upi
          })
        });
      }
      return backup_upi_kv
    },
    submit_ct() {
      let that = this;
      if (this.type === '') {
        this.$toast.failed("please select the kyc partner");
        return false;
      }
      this.link_loading = true;
      const success = this.$validator.validateAll().then(res => {
        if (res) {
          if (this.viewOperate === "edit") {
            if (this.upi === "select available upi") {
              this.$toast.failed("select available upi");
              return;
            }
            let formdata = {id: this.ct_id}
            formdata.upi = this.upi;
            formdata.pnname = this.pnname;
            editcollectiontool(formdata).then(res => {
              that.link_loading = false;
              if (res.code === 200) {
                that.$toast.succeed('save successfully');
                setTimeout(() => {
                  that.$router.push("/kycpartner");
                }, 2000);
              } else {
                that.$toast.failed(res.errmsg);
              }
            }).catch(error => {
              console.log(error);
              that.$toast.failed("Network Error!");
              that.link_loading = false;
            })
          } else {
            monitorflowone({
              ct_type: that.type,
              account: that.account,
              pnname: that.pnname
            }).then(res => {
              that.link_loading = false;
              if (res.code === 200) {
                that.monitor_pk = res.data.pk;
                if (that.monitor_pk === "" || that.monitor_pk === null || that.monitor_pk === undefined) {
                  that.$toast.failed("please try again");
                  return;
                }
                monitorflowtwo({
                  pk: that.monitor_pk
                }).then(res => {
                  if (res.code === 200) {
                    // 启动客户端，启用轮询
                    this.$toast.loading("check kyc...", 10000);
                    this.monitor_check(true);
                  } else {
                    that.$toast.failed(res.errmsg);
                  }
                })
              } else if (res.code === 400 && res.errmsg === "noneedlogin") {
                that.$toast.loading("sync kyc...", 10000);
                that.monitor_check(true);
                that.viewOperate = "edit";
                that.edit = true;
                //that.$router.push("/editkycpartner/edit/"+ that.ct_id);
                //editkycpartner/edit/15093
              } else {
                that.$toast.failed(res.errmsg);
              }
            }).catch(error => {
              console.log(error);
              that.$toast.failed("Network Error!");
              that.link_loading = false;
            })
          }
        } else {
          that.link_loading = false;
          return
        }
      })
    },
    client_login() {
      console.log("client_login");
      let startapp_webview = {
        "pk": this.monitor_pk,
        "ct_type": this.type,
        "account": this.account
      }
      let startapp_webview_str = encodeURI(JSON.stringify(startapp_webview));
      this.linkurl = "xaml:" + startapp_webview_str;
      let that = this;
      console.log("app web start", this.linkurl);
      setTimeout(() => {
        try {
          that.$refs.myLink.click();
          console.log("app web start success");
        } catch (error) {
          console.log("app web start fail", error);
        }
      }, 1500);
    },
    monitor_check(first) {
      if (this.check_count > 20) {
        this.check_fail_after();
        return;
      }
      this.$toast.hide();
      this.$toast.loading("check kyc...", 12000);
      monitorflowcheck({
        ct_type: this.type,
        account: this.account
      }).then(res => {
        if (res.code === 200) {
          this.check_count += 1;
          let state = res.data.state;
          if (state === "idle" || state === "receiving") {
            this.check_success_after(res.data);
            return;
          }
          if (state === "loginerror") {
            this.check_fail_after("login failed");
            return;
          }
        }
        console.log("轮询结果: ", first);
        if (first) {
          this.client_login();
          let that = this;
          that.monitor_check_interval = setInterval(() => {
            that.monitor_check(false);
          }, 5000);
        }
      }).catch(error => {
        console.log("轮询报错: ", error);
      })
    },
    check_success_after(data) {
      this.$toast.hide();
      this.$toast.succeed("kyc suuccess");
      this.check_count = 0;
      this.backup_upi = this.format_backup_upi(data.backup_upi);
      this.viewOperate = "edit";
      this.ct_id = data.id;
      window.clearInterval(this.monitor_check_interval);
    },
    check_fail_after() {
      this.check_count = 0;
      this.$toast.hide();
      this.$toast.failed("kyc timeout");
      window.clearInterval(this.monitor_check_interval);
    },
    showSelector() {
      this.isSelectorupiShow = true
    },
    onSelectorChoose({text}) {
      this.upi = text
    },
  },
  beforeDestroy() {
    window.clearInterval(this.monitor_check_interval);
  }
}

</script>
<style scoped>
.upi-tips {
  margin-top: 0.3rem;
  color: #46ac2a;
  font-size: 0.20rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/forms/clientlogin.vue